import * as d3 from 'd3';
import { chain } from 'lodash';
import React from 'react';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import moment from 'moment';

export interface VolumeLargeSvgProps {
  keyword: ProjectKeywordGq;
  longMonthDisabled: boolean;
  startMonth?: string;
  endMonth?: string;
}

const mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const VolumeLargeSvg: React.FC<VolumeLargeSvgProps> = React.memo(
  ({ keyword, longMonthDisabled, startMonth, endMonth }) => {
    const monthValues12 = chain(keyword.months2)
      .slice(36 - 12)
      .value();

    const maxValue12 = Math.max(chain(monthValues12).max().value() ?? 1, 1);

    const monthValues24 = chain(keyword.months2)
      .slice(36 - 24)
      .value();

    const maxValue24 = Math.max(chain(monthValues24).max().value() ?? 1, 1);

    const monthValuesChart = longMonthDisabled ? monthValues12 : monthValues24;
    const maxValueChart = longMonthDisabled ? maxValue12 : maxValue24;

    // Styling
    const barWidth = 14;
    let currentMonth = moment.utc(endMonth).add(-24, 'months');
    return (
      <svg width={barWidth / 2 + 6 + (monthValuesChart.length - 0.5) * 26} height={280}>
        {monthValuesChart?.map((month, index) => {
          const barWidth = 14;
          const xShift = index * 26 + 4;
          const prevxShift = (index - 1) * 26 + 4;

          const textXShift = xShift + barWidth / 2;
          currentMonth.add(1, 'month');

          return (
            <g key={index}>
              <text
                textAnchor="middle"
                x={textXShift}
                y={230 - 200 * (month / maxValueChart)}
                className="font-sans font-normal text-[10px] text-voxel-gray-300"
              >
                {d3.format('.2s')(month)}
              </text>
              <rect
                height={200 * (month / maxValueChart)}
                width={barWidth}
                x={xShift}
                y={240 - 200 * (month / maxValueChart)}
                className={'fill-primary-600'}
              />
              <text
                x={textXShift}
                textAnchor="middle"
                y={260}
                className="font-sans font-normal text-[11px] text-voxel-gray-300"
              >
                {mS[currentMonth.month()]}
              </text>
              {currentMonth.month() === 0 && !longMonthDisabled && (
                <text
                  fontWeight="normal"
                  x={textXShift}
                  y={280}
                  textAnchor="middle"
                  className="font-sans font-semibold text-[12px] text-voxel-gray-500"
                >
                  {currentMonth.year()}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    );
  }
);

export default VolumeLargeSvg;
